// اللوحة تنتقل إلى عنوان جديد (kioskMove.nl.ts). النسخة العربية.
export const kioskMoveAr = {
    title: 'اللوحة تنتقل',
    body: 'للوحة العائلة عنوان جديد: {host}. ستنتقل إليه الآن تلقائيًا وتبقى مرتبطة.',
    askBody: 'للوحة العائلة عنوان جديد: {host}. اضغط على متابعة: سيفتح Safari اللوحة هناك وهي ما زالت مرتبطة. بعد ذلك نشرح كيف تضيفها إلى الشاشة الرئيسية من جديد.',
    askBodyUnpaired: 'للوحة العائلة عنوان جديد: {host}. اضغط على متابعة لفتحها هناك وربطها.',
    button: 'متابعة',
    later: 'لاحقًا',
    failed: 'الانتقال لا ينجح الآن. ستحاول اللوحة مرة أخرى بعد قليل.',
    homeTitle: 'أضف اللوحة إلى الشاشة الرئيسية من جديد',
    homeBody: 'اللوحة الآن على {host}. في Safari اضغط على مشاركة ثم على «إضافة إلى الشاشة الرئيسية». بعد ذلك افتح اللوحة فورًا من الأيقونة الجديدة واحذف الأيقونة القديمة. إذا طلبت الأيقونة الجديدة رمزًا، فاربط اللوحة من جديد في التطبيق. ثم أغلق هذا الشرح في Safari.',
    invalid: 'انتهت صلاحية رمز الانتقال هذا أو استُخدم من قبل. اربط اللوحة من جديد بالرمز الظاهر على هذه الشاشة.',
    offline: 'لا يوجد اتصال، لذلك لم ينجح الانتقال. اربط اللوحة من جديد بالرمز الظاهر على هذه الشاشة.',
    /** De ouderapp heeft deze tablet losgekoppeld (koppelscherm). */
    revoked: 'فُصل في تطبيق الوالدين.',
};
//# sourceMappingURL=kioskMove.ar.js.map